export enum ModalType {
    Default = 'default',
    Feedback = 'feedback',
    Prompts = 'prompts'
}